module.exports = __webpack_public_path__ + "static/img/ent-detail-33.f8773c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-33.jpg
// module id = xy43
// module chunks = 51